import React from 'react';
import { SiteVariablesPrepared } from '@fluentui/react-northstar';
import { IChartData } from '../ChartTypes';
import { BaseChart } from './BaseChart';


export const BarChart = ({ title, data, siteVariables, stacked }: { title: string; data: IChartData; siteVariables: SiteVariablesPrepared; stacked?: boolean; }) => {
  return <BaseChart chartType='bar' stacked={stacked} title={title} data={data} siteVariables={siteVariables} />;
};
